import { FormControl } from '@angular/forms';
import { ChangeDetectorRef, Component, DestroyRef, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { FieldValidation } from '../field-validation';
import { GeopointInterface } from '@vendasta/crm';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { tap } from 'rxjs';
import { UpdaterService } from './updater.service';
import { FieldValueInterface, ObjectType, RenderableFieldInterface } from '../../../tokens-and-interfaces';

export class GeopointFieldHandler implements RenderableFieldInterface {
  formControl: FormControl<GeopointInterface>;

  constructor(
    public objectType: ObjectType,
    public fieldId: string,
    public name: string,
    public label: string,
    public value: GeopointInterface,
    public description: string,
    public readOnly = false,
    public validation: FieldValidation = new FieldValidation(),
  ) {
    this.formControl = new FormControl<GeopointInterface>(value);
  }

  fieldValue(): FieldValueInterface {
    return {
      fieldId: this.fieldId,
      geopointValue: this.formControl.value,
    };
  }

  hasModification(): boolean {
    return this.formControl?.dirty;
  }

  setValidation(validation: FieldValidation): void {
    this.validation = validation;
    this.formControl.setValidators(validation.getValidators());
    this.formControl.setAsyncValidators(validation.getAsyncValidators());
  }

  render(viewContainerRef: ViewContainerRef): void {
    viewContainerRef.clear();
    const component = viewContainerRef.createComponent<GeopointRendererComponent>(GeopointRendererComponent);
    component.instance.fieldId = this.fieldId;
    component.instance.objectType = this.objectType;
    component.instance.control = this.formControl;
  }
}

@Component({
  template: '', //TODO: Add template for geopoint form field
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./renderers.scss'],
})
class GeopointRendererComponent {
  public fieldId!: string;
  public objectType!: ObjectType;
  public control!: FormControl<GeopointInterface>;

  constructor(
    private updaterService: UpdaterService,
    private changeDetRef: ChangeDetectorRef,
    private destroyRef: DestroyRef,
  ) {
    this.updaterService.updatedField
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        tap((data) => {
          if (
            data.geopointValue &&
            data.geopointValue.lat !== undefined &&
            data.geopointValue.lon !== undefined &&
            data.fieldId &&
            data.fieldId === this.fieldId
          ) {
            this.control.setValue(data.geopointValue);
            this.control.markAsDirty();
            this.changeDetRef.detectChanges();
          }
        }),
      )
      .subscribe();
  }
}
